import React from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Components
import Loader from '../../../components/Loader/Loader';
import { PrintBIgIcon } from '../../../components/Common/Assets/SvgIconComponent/CommonSvgIcon';
import PurchasePlanReceiptInfo from '../../../components/ServicePlanContainer/PurchasePlanReceiptInfo/PurchasePlanReceiptInfo';
import NotFound from '../../notFound/NotFound';

// Helpers / GraphQL
import { getPurchaseServicePlan } from '../../../lib/graphql';
import messages from '../../../locale/jsonMessages';

import cs from '../../../components/commonStyle.css';
import s from './PurchasePlanReceipt.css';

const PurchasePlanReceipt = (props) => {
    const { title, id } = props;
    const { formatMessage } = useIntl();

    const { data, loading } = useQuery(getPurchaseServicePlan, {
        variables: { id: Number(id) },
        fetchPolicy: 'network-only',
        ssr: false,
    });

    const print = () => {
        window.print();
    };

    if (loading) {
        return <Loader type="text" />;
    }

    const status = data?.getPurchaseServicePlan?.status;
    const paymentState = data?.getPurchaseServicePlan?.result?.paymentState;

    if ((!loading && status === 400) || (!loading && paymentState !== 'completed')) {
        return <NotFound />;
    }

    if (!loading && status === 200 && paymentState === 'completed') {
        return (
            <div className={s.purchasePlanPaymentContainer}>
                <div className={s.container}>
                    <div className={s.purchasePlanPaymentRow}>
                        <div className={s.purchasePlanPaymentCol}>
                            <div className={cx(cs.spaceBottom4, s.purchasePlanPaymentHeader)}>
                                <div>
                                    <h1 className={cx(cs.commonTitleText, cs.fontWeightBold, cs.paddingBottom1)}>{formatMessage(messages.customerReceipt)}&nbsp;</h1>
                                    <p className={cx(cs.commonContentText, cs.fontWeightNormal)}>
                                        <span className={cs.displayinlineBlock}><FormattedMessage {...messages.receipt} />:</span>
                                        <span className={cs.displayinlineBlock}>&nbsp;#{id}</span>
                                    </p>
                                </div>
                                <Button onClick={print} className={cx(cs.btnPrimary, "hidden-print", cs.displayInlineBlock)}>
                                    <PrintBIgIcon className={cx(s.purchasePlanPrintBtnIcon, 'purchasePlanPrintBtnIconRtl')} />
                                    <FormattedMessage {...messages.print} />
                                </Button>
                            </div>
                            <PurchasePlanReceiptInfo data={data?.getPurchaseServicePlan?.result} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return <span></span>;
};

export default withStyles(cs, s)(PurchasePlanReceipt);
